module.exports = "../../static/img/loader-bike.943b6e9.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/loader-bike.gif
// module id = 196
// module chunks = 0